import Vue from "vue"
import axios from "axios"
import moment from "moment"
import Notify from "vue2-notify"
import UiKit from "@hudlab/ui-kit"
import Paginate from "vuejs-paginate"
import helperResource from "@/mixins/helperResource"
import helperLang from "@/mixins/helperLang"

import { library } from "@fortawesome/fontawesome-svg-core"

// ! Optimize icon imports before production
import { fal } from "@fortawesome/pro-light-svg-icons"
import { far } from "@fortawesome/pro-regular-svg-icons"
import { fas } from "@fortawesome/pro-solid-svg-icons"
import { fad } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

import VeeValidate, { Validator } from "vee-validate"
import sl from "vee-validate/dist/locale/sl"

/**
 * Axios - requests
*/
window.axios = axios.create({ baseURL: process.env.VUE_APP_API })
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
window.axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"
window.axios.defaults.withCredentials = true
window.axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.reject(error)
})

/**
 * Uikit init
 */
Vue.use(UiKit)

/**
 * Validator
 */
Vue.use(VeeValidate)
Validator.localize("sl", sl)

/**
 * Moment - date and time management
 */
window.moment = moment
Vue.prototype.moment = moment
moment.locale("sl")

/**
 * Notify - notifications
 */
Vue.use(Notify, {
  itemClass: "notification",
  position: "bottom-right"
})
const types = {
  info: { itemClass: "notification--info" },
  error: { itemClass: "notification--error" },
  warning: { itemClass: "notification--warning" },
  success: { itemClass: "notification--success" }
}
Vue.$notify.setTypes(types)

/**
 * Fontawesome
 *
 */
library.add(fal, far, fas, fad)
Vue.component("Icon", FontAwesomeIcon)

/**
 * Pagination
 */
Vue.component("paginate", Paginate)

/**
 * vuex-i18n and translation helpers
 */
Vue.use(helperLang)

/**
 * Resource helpers mixin
 */
Vue.use(helperResource)
